/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Typography,
  Spin,
  Input,
  Modal,
  message,
  Alert,
  Card,
  notification,
  DatePicker,
} from 'antd';
import * as XLSX from 'xlsx';
import API from 'utils/api';
import { CheckCircleOutlined, CloseCircleOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import Uploader from 'components/Uploader';
import {
  getEstadosGlobales,
} from 'api/catalogos';
import {
  getCargasReportesReloj,
  postCargaReporteReloj,
  deleteCargaReporteReloj,
  patchCargaReporteReloj,
  getCargaReporteReloj,
  autorizarCargaReporteReloj,
  putCargaReporteReloj,
  getCargasReportesRelojPag,
  getCargaReporteRelojErrores,
  CancelarCargaReporteReloj,
} from 'api/configuraciones/clock/CargaReporteReloj/CargaReporteReloj';
import {
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
} from 'utils/constants';
import { getIncidenciasCargas } from 'api/configuraciones/clock/Incidencias/IncidenciaCarga';
import moment from 'moment';
import { getModelPermission } from 'utils/permission';
import ModalErroresControls from 'components/ModalErroresControls';
import {
  excelFloatToDate,
  formatTime,
  formatLapse,
  getDayName,
  formatDate,
  formatDateYYYYMMDD,
} from 'api/configuraciones/clock/CargaReporteReloj/ExcellTimeFormater';
import CargaReporteXlsReloj from './CargaReporteXlsReloj';

export const CargaReporteRelojPermission = {
  permissionModel: 'cargadereporte',
  catalogsModels: [],
  tabsModels: [],
};

const cargaReporteXlsPermision = 'cargadereportedetalle';

const { Text } = Typography;

const CargaReporteReloj = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(true);
  const [incidenciaCarga, setIncidenciaCarga] = useState([]);
  const registrosExcelRef = useRef([]);
  const [payloadRegistros, setPayloadRegistros] = useState(null);
  const [excelUpdateKey, setExcelUpdateKey] = useState(0);
  const [usarRegistrosLocales, setUsarRegistrosLocales] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [progresoLotes, setProgresoLotes] = useState(null);
  const [parseandoArchivo, setParseandoArchivo] = useState(false);
  const [isPolling, setIsPolling] = useState(false);
  const [idEnProceso, setIdEnProceso] = useState(null);
  const pollingRef = useRef(null);
  const [errores, setErrores] = useState([]);
  const [pageActual, setPageActual] = useState(1);
  const [visibleErrores, setVisibleErrores] = useState(false);
  const [confirmationVisible, setConfirmationVisible] = useState(false);

  const onErrors = () => {
    setVisibleErrores(true);
  };

  // Convierte letra(s) de columna Excel a índice 0-based (A=0, B=1, Z=25, AA=26, ...)
  const colLetterToIndex = (letter) => {
    const upper = (letter || '').trim().toUpperCase();
    let result = 0;
    for (let i = 0; i < upper.length; i += 1) {
      result = result * 26 + (upper.charCodeAt(i) - 64);
    }
    return result - 1;
  };

  const getXlsInformationByColumns = (columns, sheetData) => sheetData.map((row) => {
    const newRow = {};
    columns.forEach(([colName, letter]) => {
      const idx = colLetterToIndex(letter);
      newRow[colName] = (idx >= 0 && row?.[idx] !== undefined) ? row[idx] : '';
    });
    return newRow;
  });

  const handleArchivoSubido = async (file) => {
    // Leer/procesar el Excel es trabajo sincrono en el hilo principal del navegador
    // (puede tardar varios segundos con archivos de cientos de miles de filas), asi
    // que sin este estado la pantalla se ve "congelada" hasta que termina. El
    // pequeño setTimeout(0) le da tiempo al navegador de pintar el spinner antes de
    // arrancar ese trabajo pesado.
    setParseandoArchivo(true);
    await new Promise((resolve) => { setTimeout(resolve, 0); });
    try {
      // 1. Validar configuración del reloj seleccionado (esta paginado, ocupo results)
      const allConfigReloj = incidenciaCarga.results;
      if (!Array.isArray(allConfigReloj) || allConfigReloj.length === 0) {
        message.error('La configuración de columnas aún no está cargada. Intenta de nuevo.');
        return;
      }

      const idTipoReloj = form.getFieldValue('tipo_de_reloj_checador');
      const configReloj = allConfigReloj.find(
        (c) => c.tipo_de_reloj_checador.id === idTipoReloj,
      );

      if (!configReloj) {
        message.error('Selecciona primero el Reloj Checador antes de cargar el archivo');
        return;
      }

      // 2. Leer archivo Excel
      const datas = await file.arrayBuffer();
      const workbook = XLSX.read(datas, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });

      // 3. Recortar desde el renglón configurado para este reloj y descartar filas vacías
      const inicio = configReloj.renglon_donde_inicia_la_informacion;
      if (!inicio || inicio > sheetData.length) {
        message.error(
          'El renglón donde inicia la información configurado para este Reloj Checador no es válido para este archivo.',
        );
        return;
      }
      // Conserva el renglón real del Excel (para el historial de errores) junto con cada fila,
      // ya que el filtro de filas vacías desalinearía el conteo si se calculara después.
      const dataRowsConRenglon = sheetData.slice(inicio - 1)
        .map((row, idx) => ({ row, renglon: inicio + idx }))
        .filter(({ row }) => Array.isArray(row) && row.some((cell) => cell !== ''));

      if (!dataRowsConRenglon.length) {
        message.error('No se encontraron registros a partir del renglón configurado.');
        return;
      }

      // 4. Extraer las columnas configuradas para este reloj
      const registerToFilter = [
        ['fecha', configReloj.columna_de_fecha_de_registro],
        ['numero_de_empleado', configReloj.columna_de_numero_de_empleado],
        ['empleado', configReloj.columna_de_nombre_de_empleado],
        ['hora_entrada', configReloj.columna_de_hora_de_entrada],
        ['hora_salida', configReloj.columna_de_hora_de_salida],
      ];
      const registros = getXlsInformationByColumns(
        registerToFilter,
        dataRowsConRenglon.map((d) => d.row),
      );

      const payload = [];
      const ref = [];
      // 5. Formatea fechas/horas y calcula el tiempo trabajado
      registros.forEach((row, idx) => {
        if (!row.numero_de_empleado) return;

        const { renglon } = dataRowsConRenglon[idx];
        const startDate = excelFloatToDate(row.hora_entrada);
        const endDate = excelFloatToDate(row.hora_salida);

        // Fecha priorizando columna fecha, si existe
        const fechaDate = row.fecha ? excelFloatToDate(row.fecha) : startDate;
        const numeroDeEmpleado = String(row.numero_de_empleado);
        const horaEntradaFmt = formatTime(startDate);
        const horaSalidaFmt = formatTime(endDate);
        const tiempoTrabajadoFmt = formatLapse(startDate, endDate);

        // Vista previa local: incluye nombre y día, solo para mostrarlos en pantalla
        ref.push({
          renglon,
          fecha: formatDate(fechaDate),
          numero_de_empleado: numeroDeEmpleado,
          nombre_enpleado: row.empleado,
          hora_entrada: horaEntradaFmt,
          hora_salida: horaSalidaFmt,
          tiempo_trabajado: tiempoTrabajadoFmt,
          dia_semana_nombre: getDayName(fechaDate),
        });

        // Payload a enviar al backend: solo los campos que realmente consume
        // (nombre/día no se usan ahí), para no inflar el tamaño de la petición
        // en archivos de decenas de miles de filas.
        payload.push({
          renglon,
          fecha: formatDateYYYYMMDD(fechaDate),
          numero_de_empleado: numeroDeEmpleado,
          hora_entrada: horaEntradaFmt,
          hora_salida: horaSalidaFmt,
          tiempo_trabajado: tiempoTrabajadoFmt,
        });
      });

      if (!payload.length) {
        message.error('Ningún registro tiene un número de empleado válido.');
        return;
      }

      // 6. Guardar el payload para enviarlo al confirmar el formulario
      registrosExcelRef.current = ref;
      setPayloadRegistros(payload);
      setExcelUpdateKey((prev) => prev + 1);
      setUsarRegistrosLocales(true);

      form.setFieldsValue({ cargar_archivo: file.name });
      message.success(
        `Archivo leído correctamente. ${payload.length} registros listos para enviar.`,
      );
    } catch (error) {
      message.error('Error al leer el archivo');
    } finally {
      setParseandoArchivo(false);
    }
  };

  const formInstances = [
    form,
  ];

  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, ''));
      const _data = await getCargasReportesRelojPag({ page: cleanPage, ...q });

      const { results } = _data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ..._data, results: [...results] });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const fetchAllErrores = async (params) => {
    let allResults = [];
    let page = 1;
    let hasNext = true;

    while (hasNext) {
      // eslint-disable-next-line no-await-in-loop
      const response = await getCargaReporteRelojErrores({ ...params, page });
      if (response?.results?.length) {
        allResults = allResults.concat(response.results);
      }
      hasNext = !!response?.next;
      page += 1;
    }

    return allResults;
  };

  const baseURI = '/relojchecador/carga-de-reporte/';

  const fetchData = async (page = 1, q = null) => {
    setLoading(true);
    const _data = await API.get(baseURI, { params: { page, ...q } });
    const { results } = _data.data;
    setData({ ..._data.data, results });
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _estados,
        _data,
        _incidenciaCarga,
      ] = await Promise.all([
        getEstadosGlobales(),
        getCargasReportesReloj(),
        getIncidenciasCargas({ estados_globales: ESTATUS_AUTORIZADO }),
      ]);
      if (mounted) {
        setEstados(_estados);
        setData(formatReceived(_data));
        setIncidenciaCarga(_incidenciaCarga);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAlert(false);
    setConfirmationVisible(false);
    setVisibleCancelar(false);
    // setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
    setPayloadRegistros(null);
    registrosExcelRef.current = [];
    setIdEnProceso(null);
    setIsPolling(false);
    setProgresoLotes(null);
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }
    fetchData(pageActual); // recarga la tabla
    setUsarRegistrosLocales(false);
  };

  const onConfirmCancelar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede modificar una carga ya cancelada');
        return;
      }
      const saved = await CancelarCargaReporteReloj(key);

      if (saved) {
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    try {
      // responseData (cuando se pasa explícitamente, p. ej. al terminar de guardar
      // una carga nueva) es la fuente de verdad más reciente -- selectedRowKeys puede
      // seguir reflejando el valor de un render anterior (closure obsoleta) en ese
      // mismo instante, ya que setSelectedRowKeys no actualiza el valor leído de
      // forma síncrona dentro de la misma función que lo invocó.
      const [selectedKey] = selectedRowKeys;
      const key = responseData?.id ?? selectedKey;
      if (!key) {
        message.warn('No se encontró el registro seleccionado');
        return;
      }
      const match = responseData || data?.results?.find((item) => item.id === key);
      const _cargaReporte = await getCargaReporteReloj(match.id);
      const formValues = {
        // Formatea la información recibida (según lógica definida en formatReceived)
        ...formatReceived(_cargaReporte),
        tipo_de_reloj_checador: _cargaReporte.tipo_de_reloj_checador.id,
        fecha_carga: _cargaReporte.fecha_carga ? moment(_cargaReporte.fecha_carga) : null,
        fecha_inicial: _cargaReporte.fecha_inicial
          ? moment(_cargaReporte.fecha_inicial) : null,
        fecha_final: _cargaReporte.fecha_final
          ? moment(_cargaReporte.fecha_final) : null,
        // Convierte la fecha de vigencia final a objeto moment si existe, si no null
        estados_globales: _cargaReporte.estados_globales?.id, //  aquí sí es un ID
      };
      //  Consultar errores asociados al registro
      const erroresResp = await getCargaReporteRelojErrores({
        carga_de_reporte: key,
      });
      if (erroresResp?.results?.length) {
        setErrores(erroresResp.results); //  Mostrar alerta e historial
      } else {
        setErrores([]); //  Nada que mostrar
        setVisibleErrores(false);
      }
      form.resetFields();
      setTimeout(() => {
        form.setFieldsValue(formatReceived(formValues));
        setDisableFields(true);
        setVisible(true);
      });
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const onClickAdd = () => {
    setSelectedRowKeys([]);
    setSelectedData({});
    setErrores([]);
    setVisibleErrores(false);
    setPayloadRegistros(null);
    registrosExcelRef.current = [];
    setUsarRegistrosLocales(false);
    setExcelUpdateKey((prev) => prev + 1);
    form.resetFields();
    setDisableFields(false);
    setVisible(true);
  };

  useEffect(() => {
    // Si no hay polling activo o no hay ID en proceso, no hacer nada
    if (!isPolling || !idEnProceso) {
      return () => { };
    }

    // Inicia el intervalo cada 5 segundos
    pollingRef.current = setInterval(async () => {
      try {
        const resultado = await getCargaReporteReloj(idEnProceso);

        // Si la carga fue exitosa
        if (resultado) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
          setIsPolling(false);
          setIdEnProceso(null);
          setUsarRegistrosLocales(false);

          notification.success({
            message: 'Carga completada',
            description: 'La carga de descuentos finalizó correctamente.',
            placement: 'topRight',
          });

          await fetchData(pageActual);
          setSelectedRowKeys([resultado.id]);
          onClickEdit({ id: resultado.id });
          return;
        }

        //  Si hay errores registrados en el backend
        const erroresResp = await fetchAllErrores({ carga_de_reporte: idEnProceso });

        if (erroresResp?.length) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
          setIsPolling(false);
          setIdEnProceso(null);

          setErrores(erroresResp);
          setVisibleErrores(true);

          notification.error({
            message: 'Errores en la carga',
            description: 'Se encontraron errores durante la carga. Revisa el historial para más detalles.',
            placement: 'topRight',
          });
        }
      } catch (err) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
        setIsPolling(false);
        setIdEnProceso(null);

        notification.error({
          message: 'Error de comunicación',
          description: 'Ocurrió un error al verificar el estado de la carga.',
          placement: 'topRight',
          duration: 6,
        });

        onError(err);
      }
    }, 5000);

    // Limpieza al desmontar o al cambiar dependencias
    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    };
  }, [isPolling, idEnProceso]);

  // Tamaño de lote calculado para que cada petición se mantenga muy por debajo
  // de los límites de tamaño de petición del servidor (Django/nginx), incluso
  // para archivos de cientos de miles de renglones como los del reloj checador.
  const TAMANIO_LOTE = 50000;
  const MAX_INTENTOS_ESPERA = 600; // ~30 minutos a intervalos de 3s

  // El motor de carga (crear_carga_de_reporte_empleado) solo permite una
  // operación en curso a la vez para esta Carga de Reporte, así que hay que
  // esperar a que el backend termine de procesar un lote (fecha_final_carga
  // se actualiza al finalizar esa corrida) antes de enviar el siguiente.
  const esperarProcesamientoDeCarga = async (cargaId, desde) => {
    for (let intento = 0; intento < MAX_INTENTOS_ESPERA; intento += 1) {
      // eslint-disable-next-line no-await-in-loop
      await new Promise((resolve) => { setTimeout(resolve, 3000); });
      // eslint-disable-next-line no-await-in-loop
      const resultado = await getCargaReporteReloj(cargaId);
      if (resultado?.fecha_final_carga && moment(resultado.fecha_final_carga).isAfter(desde)) {
        return resultado;
      }
    }
    throw new Error('Tiempo de espera agotado procesando la carga.');
  };

  const enviarRegistrosPorLotes = async (cargaId, registros) => {
    const totalLotes = Math.ceil(registros.length / TAMANIO_LOTE);
    let ultimoResultado = null;
    try {
      for (let i = 0; i < totalLotes; i += 1) {
        const lote = registros.slice(i * TAMANIO_LOTE, (i + 1) * TAMANIO_LOTE);
        setProgresoLotes({ actual: i + 1, total: totalLotes });
        const desde = new Date();
        // eslint-disable-next-line no-await-in-loop
        await putCargaReporteReloj(cargaId, lote);
        // eslint-disable-next-line no-await-in-loop
        ultimoResultado = await esperarProcesamientoDeCarga(cargaId, desde);
      }
    } finally {
      setProgresoLotes(null);
    }
    return ultimoResultado;
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;

      if (!key && !payloadRegistros?.length) {
        message.error('Debes cargar un archivo con los registros antes de guardar.');
        setLoading(false);
        return;
      }
      // eslint-disable-next-line max-len
      // 4. Clonar los datos del formulario para enviarlos

      values.fecha_carga = values.fecha_carga?.format('YYYY-MM-DD');
      values.fecha_inicial = values.fecha_inicial?.format('YYYY-MM-DD');
      values.fecha_final = values.fecha_final?.format('YYYY-MM-DD');

      delete values.reemplazo_de_archivo;
      delete values.archivo;

      const datosAEnviar = { ...values };

      const saved = await (
        key
          ? patchCargaReporteReloj(key, values) : postCargaReporteReloj(values)
      );

      // 6. Si es nuevo y hay registros cargados desde el Excel, enviarlos en lotes,
      // esperando a que el backend termine de procesar cada uno antes del siguiente
      if (!key && saved?.id && payloadRegistros?.length) {
        setSelectedRowKeys([saved.id]);
        setSelectedData(saved);

        await enviarRegistrosPorLotes(saved.id, payloadRegistros);

        const erroresResp = await fetchAllErrores({ carga_de_reporte: saved.id });
        if (erroresResp?.length) {
          setErrores(erroresResp);
          setVisibleErrores(true);

          notification.error({
            message: 'Errores en la carga',
            description: 'Se encontraron errores durante la carga. Revisa el historial para más detalles.',
            placement: 'topRight',
          });
        } else {
          notification.success({
            message: 'Carga completada',
            description: 'La carga de registros finalizó correctamente.',
            placement: 'topRight',
          });
        }

        setLoading(false);
        // Regresa al listado (en vez de dejar abierto el registro recién creado) para
        // que se vea de inmediato junto con los demás, con su estatus actualizado.
        onCancel();
        return;
      }

      if (saved) {
        if (_continue) {
          await fetchData(pageActual);
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteCargaReporteReloj(key);
        if (deleted) {
          onCancel();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = async (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });
    const dataForForm = {
      ...record,
      fecha_carga: record.fecha_carga
        ? moment(record.fecha_carga)
        : null,
      fecha_inicial: record.fecha_inicial
        ? moment(record.fecha_inicial)
        : null,
      fecha_final: record.fecha_final
        ? moment(record.fecha_final)
        : null,

    };
    form.setFieldsValue(dataForForm);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una carga ya autorizado');
        return;
      }
      const saved = await autorizarCargaReporteReloj(key);
      if (saved) {
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Fecha de Carga',
      dataIndex: 'fecha_carga',
      key: 'fecha_carga',
      width: 200,
    },
    {
      titleText: 'Reloj Checador',
      dataIndex: 'tipo_de_reloj_checador',
      key: 'tipo_de_reloj_checador',
      width: 150,
      render: (_, record) => record?.tipo_de_reloj_checador?.nombre || 'n/a',
    },
    {
      titleText: 'Folio',
      dataIndex: 'folio',
      key: 'folio',
      width: 100,
    },
    {
      titleText: 'Fecha Inicial del Reporte',
      dataIndex: 'fecha_inicial',
      key: 'fecha_inicial',
      width: 200,
    },
    {
      titleText: 'Fecha Final del Reporte',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 200,
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 400,
    }, /*
    {
      titleText: 'Nombre del Archivo',
      dataIndex: 'cargar_archivo',
      key: 'cargar_archivo',
      width: 400,
    }, */
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      render: (_, record) => record?.estados_globales?.descripcion || 'n/a',
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row className="container">
      <Spin
        tip={
          progresoLotes
            ? `Enviando lote ${progresoLotes.actual} de ${progresoLotes.total}...`
            : 'Cargando...'
        }
        spinning={loading && !isPolling}
      >
        {!open ? (
          <Table
            cols={columns}
            data={data?.results || []}
            pagination={false}
            paginationCallback={fetchPaginated}
            count={data?.count || 0}
            rowSelection={rowSelection}
            currentPage={pageActual}
            onRow={(record) => ({
              onClick: () => handleOnRowClick(record),
              onDoubleClick: () => onClickEdit(record),
            })}
            controls={{ onClickAdd }}
            customActions={[
              {
                onClick: () => onClickEdit(),
                text: 'Visualizar',
                icon: <UnorderedListOutlined />,
                disabledBySelection: true,
              },
              {
                permission: { model: 'cargadereporte', action: 'cancelar' },
                onClick: () => setVisibleCancelar(true),
                text: 'Cancelar',
                icon: <CloseCircleOutlined />,
                disabledBySelection: true,
                // Una carga ya Cancelada es definitiva: no se puede volver a cancelar,
                // editar ni autorizar.
                disabled: selectedData?.estados_globales?.id === ESTATUS_CANCELADO,
                className: 'cancel',
              },
              {
                onClick: () => setConfirmationVisible(true),
                permission: { model: 'cargadereporte', action: 'autorizar' },
                icon: <CheckCircleOutlined />,
                text: 'Autorizar',
                disabledBySelection: true,
                disabled: selectedData?.estados_globales?.id === ESTATUS_CANCELADO,
                className: 'success',
              },
            ]}
            disableDelete={selectedData?.estados_globales?.id !== ESTATUS_ACTIVO}
            permission={permission}
            allowExportParam={false}
          />
        )
          : (

            <>
              {
                errores.length ? (
                  <Alert
                    description={(
                      <code>
                        <Text>
                          Ha ocurrido un error
                        </Text>
                        <br />
                        Favor de consultar el
                        <Text
                          style={{
                            color: '#CF9660',
                            paddingLeft: '3px',
                            paddingRight: '3px',
                          }}
                        >
                          Historial de Errores
                        </Text>
                        para obtener mas información
                      </code>
                    )}
                    type="warning"
                    showIcon
                    closable
                    style={{ textAlign: 'center', alignItems: 'center' }}
                  />
                ) : null
              }
              {progresoLotes && (
                <Alert
                  message={`Enviando registros: lote ${progresoLotes.actual} de ${progresoLotes.total}. No cierres ni recargues la página.`}
                  type="info"
                  showIcon
                  style={{ marginBottom: 16 }}
                />
              )}
              <Card
                className="form-container"
                title="Revisar Reporte Del Reloj Checador"
                extra={(
                  <FormSubmitControls
                    onCancel={onCancel}
                    onFinish={onFinish}
                    loading={loading}
                    onFinishText="Guardar y Continuar"
                    onErrors={errores.length ? onErrors : null}
                  />
                )}
                bordered={false}
              >

                <Form
                  layout="vertical"
                  form={form}
                  onFinish={onFinish}
                  scrollToFirstError
                  name="general"
                  initialValues={{
                    estados_globales: ESTATUS_ACTIVO,
                    reemplazo_de_archivo: false,
                  }}
                >
                  <Row gutter={10}>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        name="fecha_carga"
                        label="Fecha de Carga"
                      >
                        <DatePicker
                          allowClear
                          format="YYYY-MM-DD"
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        name="tipo_de_reloj_checador"
                        rules={rules.required}
                        label="Reloj Checador"
                      >
                        <Select
                          dataSource={incidenciaCarga.results.map((item) => (
                            {
                              id: item.tipo_de_reloj_checador.id,
                              descripcion: item.tipo_de_reloj_checador.nombre,
                            }
                          ))}
                          disabled={disableFields}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        name="folio"
                        label="Folio"
                      >
                        <Input
                          allowClear
                          disabled={disableFields}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        name="fecha_inicial"
                        rules={rules.required}
                        label="Fecha Inicial"
                      >
                        <DatePicker
                          allowClear
                          format="YYYY-MM-DD"
                          disabled={disableFields}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        name="fecha_final"
                        rules={rules.required}
                        label="Fecha Final"
                      >
                        <DatePicker
                          allowClear
                          format="YYYY-MM-DD"
                          disabled={disableFields}
                        />
                      </Form.Item>
                    </Col>
                    {/*
                  <Col xs={24} sm={8}>
                    <Form.Item
                      name="reemplazo_de_archivo"
                      rules={rules.required}
                      label="Reemplazo de Archivo"
                    >
                      <Select
                        trueFalse
                        disabled={
                          disableFields
                        }
                      />
                    </Form.Item>
                  </Col> */}

                    <Col xs={24} sm={8}>
                      <Form.Item
                        name="estados_globales"
                        label="Estatus"
                        hasFeedback
                      >
                        <Select
                          labelProp="descripcion"
                          keyProp="id"
                          dataSource={estados}
                          activeInactive={selectedData?.estados_globales?.id === ESTATUS_ACTIVO}
                          disabled={selectedRowKeys.length <= 0 || disableFields}
                          onChange={(val) => setVisibleConfirmInactivo(val === ESTATUS_INACTIVO)}
                        />
                      </Form.Item>
                    </Col>
                    <Form.Item
                      shouldUpdate={
                        (prev, cur) => prev.tipo_de_reloj_checador !== cur.tipo_de_reloj_checador
                      }
                      noStyle
                    >
                      {({ getFieldValue }) => (
                        <Uploader
                          title="Cargar Archivo"
                          limitMB={20}
                          file={getFieldValue('archivo')}
                          formItemName="archivo"
                          allowedExtensions={['xlsx']}
                          allowPreview={false}
                          onUpload={handleArchivoSubido}
                          disabled={
                            disableFields
                            || !getFieldValue('tipo_de_reloj_checador')
                            || parseandoArchivo
                          }
                        />
                      )}
                    </Form.Item>
                    {parseandoArchivo && (
                      <Col xs={24} sm={8}>
                        <Spin size="small" />
                        <Text style={{ marginLeft: 8 }}>
                          Procesando archivo, espera un momento...
                        </Text>
                      </Col>
                    )}
                    <Col xs={24} sm={8}>
                      <Form.Item
                        name="cargar_archivo"
                        rules={rules.required}
                        label="Nombre del Archivo"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24}>
                      <Form.Item
                        name="observaciones"
                        label="Observaciones"
                      >
                        <Input
                          allowClear
                          disabled={disableFields}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item hidden>
                    <Button htmlType="submit" />
                  </Form.Item>
                </Form>
                <CargaReporteXlsReloj
                  key={excelUpdateKey}
                  // eslint-disable-next-line max-len
                  CargaReportePadre={selectedData}
                  // eslint-disable-next-line max-len
                  registrosCargados={usarRegistrosLocales ? registrosExcelRef.current : []} // <-- Aquí pasas los datos del Excel
                  permission={getModelPermission(cargaReporteXlsPermision)}
                  hideParentForm={() => setVisible(false)}
                  showParentForm={() => setVisible(true)}
                  pollingEnCurso={isPolling}
                  usarRegistrosLocales={usarRegistrosLocales}

                />
              </Card>
            </>
          )}
        <Modal
          open={visibleErrores}
          title={(
            <Row justify="space-between">
              <Text style={{ fontSize: '1.25rem' }}>
                Historial de Errores
              </Text>
              <ModalErroresControls
                onCancel={() => setVisibleErrores(false)}
              />
            </Row>
          )}
          footer={null}
          closable={false}
          width="85%"
        >
          <Table
            cols={[{
              titleText: 'Descripción de Error',
              dataIndex: 'error',
              key: 'error',
              width: 200,
            }]}
            data={errores}
            mobileColIndex={0}
          />
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={form.getFieldValue('archivo_nombre') || ''}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmCancelar}
          Confirm
          onCancel={() => setVisibleCancelar(false)}
          open={visibleCancelar}
          contentTitle={`Cancelar el Archivo ${selectedData?.archivo_nombre || ''}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar el Archivo ${selectedData?.archivo_nombre || ''}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default CargaReporteReloj;
